import { CreateOrderItem, OrderingInitialState, SetUserReturnOrderItemAction } from '@reducers/ordering/types';
import { safeString } from '@utils/stringUtil';

export const setUserReturnOrderItem = (
  state: OrderingInitialState,
  action: SetUserReturnOrderItemAction
): OrderingInitialState => {
  const { id } = action.payload;
  const menuItem = state?.orderState.order?.orderItems?.find((x) => x.id === id);
  if (menuItem) {
    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: [
          ...state.orderState.menus,
          {
            count: menuItem?.count,
            discount: menuItem?.discount || 0,
            menuItemId: menuItem?.menuItemId || '',
            title: menuItem?.title || '',
            price: menuItem?.price || 0,
            packagingCost: menuItem?.packagingCost || 0,
            servePackagingCost: menuItem?.packagingCost || 0,
            tempId: safeString(menuItem?.id),
            withTax: menuItem.withTax,
            orderItemToppings: menuItem?.toppings?.map((x) => ({
              count: menuItem?.count,
              price: x.price,
              title: x.title,
              toppingId: x.toppingId,
            })),
          } as CreateOrderItem,
        ],
        removedItems: state?.orderState.removedItems?.filter((x) => x.tempId !== id),
      },
    };
  }

  return state;
};
